import React, { useState, useEffect } from "react";
import { Card, Button, Select, Modal } from "antd";
import axios from "axios";
import { Event, NoShow } from "interfaces/events";
import dayjs from "dayjs";
import { StudentUser } from "interfaces/users";

const { Option } = Select;

const CreateTermViolation = ({ student, onSuccess }: { student: StudentUser; onSuccess: (NoShow: NoShow) => void }) => {
  const [events, setEvents] = useState<Event[]>([]);
  const [selectedEvent, setSelectedEvent] = useState<number | undefined>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get<{ results: Event[] }>(`/events/admin-events/?time_filter=past&page_size=15`).then(response => {
      setEvents(response.data.results);
    });
  }, []);

  const handleOk = () => {
    // Create term violation for the student at the selected event
    if (selectedEvent) {
      setLoading(true);
      axios
        .post<NoShow>(`/events/${selectedEvent}/create-term-violation/`, {
          student: student.id,
        })
        .then(response => {
          onSuccess(response.data);
          setSelectedEvent(undefined);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const showConfirm = () => {
    Modal.confirm({
      title: `Er du sikker på at du vil gi en prikk til ${student.first_name} ${student.last_name} for arrangementet "${
        events.find(event => event.id === selectedEvent)?.name
      }"?`,
      onOk: handleOk,
      okText: "Gi prikk",
      cancelText: "Nei",
    });
  };

  return (
    <Card title="Gi prikk">
      <Select
        style={{ width: "100%", marginBottom: "16px" }}
        placeholder="Velg et arrangement"
        onChange={value => setSelectedEvent(value)}
        notFoundContent={events.length === 0 ? "Laster inn arrangementer..." : "Ingen arrangementer funnet"}
        showSearch
        filterOption={(input, option) => {
          const children = String(option?.children);
          return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
      >
        {events.map((event: Event) => (
          <Option key={event.id} value={event.id}>
            {dayjs(event.start).format("DD.MM.YYYY")} - {event.name}
          </Option>
        ))}
      </Select>
      <Button
        type="primary"
        danger
        disabled={!selectedEvent}
        style={{
          width: "100%",
          pointerEvents: !selectedEvent ? "none" : "auto",
          cursor: !selectedEvent ? "not-allowed" : "pointer",
        }}
        loading={loading}
        onClick={showConfirm}
      >
        Gi prikk
      </Button>
    </Card>
  );
};

export default CreateTermViolation;
